module.exports = __webpack_public_path__ + "static/helvetica-neue-light-9b36197771464b27f64aaa2b30b0f662.woff2";